import { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import FirestoreService from '../../services/FirestoreService';
import GameModel, {
  GameState,
  gameStateToString,
  GameType,
  gameTypeToString,
} from './models/GameModel';
import GameData from './data/GameData';
import ErrorMessage from './components/ErrorMessage';
import FunctionsService from '../../services/FunctionsService';
import ChallengeGameClient from './ChallengeGameClient';
import PlayerModel, { CreatePlayerViewModel } from './models/PlayerModel';
import { Button } from 'antd';
import GameEventModel from './models/GameEventModel';
import CreateGameViewModel from './models/CreateGameViewModel';

export interface IAppContextState {
  hello: string;
}

// function gameDetailReducer(state: IGameDetailContextState, action: TGameAction) {
//   switch (action.type) {
//     case GameDetailActionType.SET_GAME_DETAIL:
//       return {
//         ...state,
//         detail: action.detail,
//       };
//     case GameDetailActionType.SET_GAME_PLAYERS:
//       return {
//         ...state,
//         players: action.players,
//       };
//     case GameDetailActionType.SET_GAME_EVENTS:
//       return {
//         ...state,
//         events: action.events,
//       };
//     default:
//       throw new Error();
//   }
// }

// const gameData = new GameData(new FirestoreService(), new FunctionsService());

const MyName = ({ name, onClick }: { name: string; onClick: () => void }) => {
  return <div onClick={onClick}>{name}</div>;
};

const Game = () => {
  return (
    <div>
      <MyName
        name={'hello'}
        onClick={async () => {
          await fetch('/');
        }}></MyName>
    </div>
  );
};

export default Game;
